// @core/api/endpoints/bootstrap/get_execution_progress.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetExecutionProgressResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Get execution progress
 * Returns current execution progress. Polling fallback for WebSocket /setup/progress.
 * @public This endpoint does not require authentication
 */
export async function GetExecutionProgress(
  params?: {
  },
  options?: RequestOptions
): Promise<GetExecutionProgressResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/progress`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetExecutionProgressResponse>(requestPath, { ...requestOptions, params });
}
